export default "__VITE_ASSET__BnXeoy5m__"